import React, { useState } from "react";
import {
  Avatar,
  Button,
  Paper,
  Grid,
  Typography,
  Container,
} from "@material-ui/core";
import { GoogleLogin } from "react-google-login";
import LockIcon from "@material-ui/icons/Lock";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signin, signup } from "../../reduxStore/actions/auth";
import Icon from "./icon";
import Input from "./Input";
import useStyle from "./style";

const initialState = {firstName: '', lastName: '', email: '', password: '', confirmPassword: '' };

const Auth = () => {
  const classes = useStyle();
  const [isSignup, setisSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData ] = useState(initialState);
  const dispatch  = useDispatch();
  const history = useHistory();

  const handleSwitch = () => {
    setisSignup((prevSignup) => !prevSignup);
    setShowPassword(false);
  };

  const handleShowPassword = () =>
    setShowPassword((prevShowPassword) => !prevShowPassword);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(isSignup){
      dispatch(signup(formData,history));
    } else {
      dispatch(signin(formData, history));
    }
  };

  const handleChange = (e) => {
     setFormData({...formData, [e.target.name]: e.target.value });
  };

  const googleSuccess = async (res) => {
    
   
    const result = res?.profileObj;
    const token = res?.tokenId;

    try {
      dispatch({ type:'AUTH', data: { result, token } });
      history.push('/');
            
    } catch (error) {
      console.log(error);
      
    }
  };

  const googleError = (error) => {
    console.log(error);
    console.log("Google sign in was fail, Try again later");
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper className={classes.paper} elevation={3}>
        <Avatar className={classes.avatar}>
          <LockIcon />
        </Avatar>
        <Typography variant="h5">{isSignup ? "Sign Up" : "Sign Up"}</Typography>

        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {isSignup && (
              <>
                <Input
                  name="firstName"
                  label="First Name"
                  handleChange={handleChange}
                  half
                />
                <Input
                  name="lastName"
                  label="Last Name"
                  handleChange={handleChange}
                  half
                />
              </>
            )}
            <Input
              name="email"
              label="Email Address"
              handleChange={handleChange}
              type="email"
            />
            <Input
              name="password"
              label="Password"
              handleChange={handleChange}
              type={showPassword ? "text" : "password"}
              handleShowPassword={handleShowPassword}
            />
            {isSignup && (
              <Input
                name="confirmPassword"
                label="Repeat Password"
                handleChange={handleChange}
                type="password"
              />
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              {isSignup ? "Sign Up" : "Sign In"}
            </Button>
            <GoogleLogin
              clientId="841284217268-i22fr9jchgr7av7skqjcuvgirovhltv6.apps.googleusercontent.com"
              render={(renderProps) => (
                <Button
                  className={classes.googleButton}
                  color="primary"
                  fullWidth
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                  startIcon={<Icon />}
                  variant="contained"
                >
                  Google Sign In
                </Button>
              )}
              onSuccess={googleSuccess}
              onFailure={googleError}
              cookiePolicy="single_host_origin"
            />

            <Grid container justify="flex-end">
              <Grid item>
                <Button onClick={handleSwitch}>
                  {" "}
                  {isSignup ? "already have an account" : "creat an account"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default Auth;
